import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// Reusable "additional taxonomy fields" picker — lets a user attach any Super-Admin-defined
// Taxonomy category to a record as a free-standing key/value field (values.category_id = value).
export const TaxonomyCustomFields = ({ categories = [], customFieldKeys = [], setCustomFieldKeys, values = {}, onChange, testPrefix = 'custom-field' }) => {
  const addable = categories.filter(c => !customFieldKeys.includes(c.id));
  return (
    <div className="space-y-4">
      {customFieldKeys.map(key => {
        const cat = categories.find(c => c.id === key);
        if (!cat) return null;
        const options = (cat.items || []).filter(i => i.active);
        return (
          <div key={key} className="space-y-2" data-testid={`${testPrefix}-${key}`}>
            <div className="flex items-center justify-between">
              <Label>{cat.label}</Label>
              <button
                type="button"
                onClick={() => {
                  setCustomFieldKeys(prev => prev.filter(k => k !== key));
                  const next = { ...values };
                  delete next[key];
                  onChange(next);
                }}
                className="text-[11px] text-muted-foreground hover:text-red-600"
                data-testid={`remove-${testPrefix}-${key}`}
              >
                Remove
              </button>
            </div>
            <Select value={values[key] || ''} onValueChange={(v) => onChange({ ...values, [key]: v })}>
              <SelectTrigger data-testid={`${testPrefix}-select-${key}`}><SelectValue placeholder="Select..." /></SelectTrigger>
              <SelectContent>{options.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        );
      })}
      {addable.length > 0 ? (
        <Select value="" onValueChange={(key) => setCustomFieldKeys(prev => [...prev, key])}>
          <SelectTrigger className="border-dashed text-muted-foreground" data-testid={`${testPrefix}-add-select`}>
            <SelectValue placeholder="+ Add Taxonomy Field" />
          </SelectTrigger>
          <SelectContent>{addable.map(c => <SelectItem key={c.id} value={c.id}>{c.label}</SelectItem>)}</SelectContent>
        </Select>
      ) : customFieldKeys.length === 0 ? (
        <p className="text-sm text-muted-foreground">No taxonomy fields added yet.</p>
      ) : null}
    </div>
  );
};

export default TaxonomyCustomFields;
